import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div style={{ padding: '20px' }}>
      <div style={{ 
        backgroundImage: 'linear-gradient(to right, #6200ea, #0a00b6)',
        height: '300px',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '40px'
      }}>
        <div style={{
          backgroundColor: 'rgba(255,255,255,0.8)',
          padding: '20px',
          borderRadius: '8px',
          textAlign: 'center',
          maxWidth: '600px'
        }}>
          <h1 style={{ color: '#6200ea', marginBottom: '10px' }}>Clínica Oftalmológica</h1>
          <p style={{ fontSize: '18px', marginBottom: '20px' }}>Cuidamos tu salud visual con profesionales expertos</p>
          <Link to="/" style={{
            backgroundColor: '#6200ea',
            color: 'white',
            padding: '10px 20px',
            borderRadius: '4px',
            textDecoration: 'none',
            display: 'inline-block'
          }}>
            Ver Servicios
          </Link>
        </div>
      </div>
      
      <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>Nuestros Servicios Destacados</h2>
      
      <div style={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap' }}>
        <div style={{ 
          width: '280px',
          margin: '15px',
          textAlign: 'center',
          padding: '20px',
          backgroundColor: '#f9f9f9',
          borderRadius: '8px'
        }}>
          <i className="fas fa-eye" style={{ fontSize: '40px', color: '#6200ea', marginBottom: '15px' }}></i>
          <h3>Examen Visual Completo</h3>
          <p>Evaluamos tu visión para detectar problemas y recomendar el tratamiento adecuado.</p>
        </div>
        
        <div style={{ 
          width: '280px',
          margin: '15px',
          textAlign: 'center',
          padding: '20px',
          backgroundColor: '#f9f9f9',
          borderRadius: '8px'
        }}>
          <i className="fas fa-glasses" style={{ fontSize: '40px', color: '#6200ea', marginBottom: '15px' }}></i>
          <h3>Adaptación de Lentes</h3>
          <p>Prescribimos y adaptamos lentes según tus necesidades específicas.</p>
        </div>
        
        <div style={{ 
          width: '280px',
          margin: '15px',
          textAlign: 'center',
          padding: '20px',
          backgroundColor: '#f9f9f9',
          borderRadius: '8px'
        }}>
          <i className="fas fa-clinic-medical" style={{ fontSize: '40px', color: '#6200ea', marginBottom: '15px' }}></i>
          <h3>Tratamientos Especializados</h3>
          <p>Ofrecemos tratamientos para diversas patologías oculares con tecnología avanzada.</p>
        </div>
      </div>
      
      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <Link to="/" style={{
          backgroundColor: '#6200ea',
          color: 'white',
          padding: '10px 20px',
          borderRadius: '4px',
          textDecoration: 'none',
          display: 'inline-block'
        }}>
          Ver todos los servicios
        </Link>
      </div>
    </div>
  );
};

export default Home;